import React from 'react';
import { Col, FlexboxGrid, Grid, Row, Text } from 'rsuite';
import PermitRow from './PermitRow';
import pluralize from 'pluralize';
import Notice from '../user-feedback/Notice';

const PermitList = ({ licenses, registrationTypeVerbiage, ownerLabel }) => (
  <div
    role="row"
    className="content-section"
  >
    <div role="cell">
      {licenses.length === 0 ? (
        <Notice
          type="info"
          message={`No ${pluralize(registrationTypeVerbiage).toLocaleLowerCase()} match the search criteria.`}
        ></Notice>
      ) : (
        <Grid
          fluid
          className="grd-all-permits"
        >
          <FlexboxGrid
            as={Row}
            className="grd-all-permits-header all-permits-permit-row"
            align="bottom"
          >
            <Col
              xsHidden
              md={7}
            >
              <Text>Address</Text>
            </Col>
            <Col
              xsHidden
              md={3}
            >
              <Text>{registrationTypeVerbiage} Number</Text>
            </Col>
            <Col
              xsHidden
              md={3}
            >
              <Text>Status</Text>
            </Col>
            <Col
              xsHidden
              md={3}
            >
              <Text>Expiration Date</Text>
            </Col>
            <Col
              xsHidden
              md={3}
            >
              <Text>{pluralize(ownerLabel)} Name</Text>
            </Col>
            <Col
              xsHidden
              md={5}
            ></Col>
          </FlexboxGrid>
          {licenses.map((license, index) => (
            <PermitRow
              key={`license_${index}`}
              license={license}
              ownerLabel={ownerLabel}
            />
          ))}
        </Grid>
      )}
    </div>
  </div>
);

export default PermitList;
